
import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { removeElementFromArray } from '../oro-module/commonFunctions';
import FormContent from "../FormArea/FormContent";


const showInsideComponent = (fastpath, current) => {

  let x = current.props.parentState;
  let localParentState = { ...x };
  localParentState.localpage = fastpath;
  localParentState.modalname = fastpath + "_modal";
  // localParentState.currentComponent = currentComponent;
  return < FormContent
    parentState={localParentState}
    liftState={current.props.liftState}
    liftGlobalState={current.props.liftGlobalState}
    parentProps={current.props.parentProps}
  />
}


class SimpleModalCustom extends Component {
  constructor(props) {
    super(props);
    this.state = { modalopen: true };
  }


  modalclose = () => {
    const { name, parents } = this.props.component;
    const { opensimplemodals } = this.props.parentState;
    if (parents) {
      this.setState({ modalopen: false });
    } else {
      let newModals = removeElementFromArray({ arr: opensimplemodals, elem: name });
      this.props.liftGlobalState({ name: 'opensimplemodals' }, newModals);
    }
    // this.props.liftState("modalopen", false);
  }

  clearmodal = () => {
    let { parentName, st } = this.props.triggerState;
    let om = this.props.parentState.openmodals;
    let { pageData } = this.props.parentState
    if (pageData.om == undefined) {
      // console.log("hdsdsj")           
      // console.log(pageData)
      let obj = pageData[om]

      pageData[om] = {}
    }
    this.props.liftGlobalState({ name: "pageData" }, pageData);
  }

  // onkeyPress = (e)=>{
  //     console.log(e)
  //     console.log(e.keyCode)
  // }




  render() {
    // This modal will - 
    // Display plain text.
    // Display any single component e.g. text box, text area etc. 
    // Display any page component - e.g. ms13
    const { label, body, footer, parents, name, fastpath } = this.props.component;
    const { opensimplemodals } = this.props.parentState;
    let shouldDisplay = true;
    if (!parents && opensimplemodals) {
      opensimplemodals.indexOf(name) != -1 ? shouldDisplay = true : shouldDisplay = false;
    }
    return (
      <div >
        {
          shouldDisplay &&
          <Modal isOpen={this.state.modalopen} toggle={this.modalclose} >
            <ModalHeader toggle={this.modalclose}>{label}</ModalHeader>
            <ModalBody>
              {!fastpath && body}
              {fastpath && showInsideComponent(fastpath, this)}
            </ModalBody>
            <ModalFooter>
              {footer}
              <Button color="secondary" onClick={this.modalclose}>Confirm</Button>
            </ModalFooter>
          </Modal>
        }
      </div>
    );
  }
}

export default SimpleModalCustom;